export default __webpack_public_path__ + "assets/images/f4ff594efe80af84ea88a7751fe335a5.png";